module.exports = __webpack_public_path__ + "img/发色变换----自定义色值.ecd99278.png";